import classNames from 'classnames';

import lang from '../../lib/language';

import styles from './DiscoverButton.module.scss';

type Props = {
  text?: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
};

const DiscoverButton = (props: Props): JSX.Element => {
  const { text, onClick, disabled, className } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={classNames(styles.viewAllBtn, className)}
    >
      {text ?? lang.mobileFundsScreenViewAllBtn()}
    </button>
  );
};

export default DiscoverButton;
